export default __webpack_public_path__ + "static/tbc-logo-a121cc2ec9e4b35944303c29b015fe64.png";